import Provider from "../enum/Provider.enum";
import jurisdictionConfig from "../config/jurisdictions.json";

const providerDomains: Record<Provider, string[]> = {
  [Provider.ARMENIA]: [],
  [Provider.BELARUS]: [],
  [Provider.TFOS]: [],
  [Provider.UAE]: [],
  [Provider.DEFAULT]: [],
};

(jurisdictionConfig.jurisdictions ?? []).forEach((jurisdiction) => {
  const provider = jurisdiction.provider as Provider;

  if (providerDomains[provider]) {
    providerDomains[provider] = jurisdiction.domains ?? [];
  }
});

const getProvider = () => {
  const currentDomain = window.location.hostname;
  for (const [provider, domains] of Object.entries(providerDomains)) {
    if (domains.includes(currentDomain)) {
      return provider as Provider;
    }
  }

  return Provider.DEFAULT;
};

const getIsDebug = (): boolean => {
  const domain = window.location.hostname;
  return (
    domain.includes("preprod") ||
    domain.includes("dev") ||
    domain.includes("prep")
  );
};

const cleanFolders = (input: string) => {
  return input.replace(/([^\s/]+\/)+/g, "");
};

const resolveComponents = (context: any) => {
  const componentsMap: Record<string, any> = {};
  const provider = getProvider();

  // Ключи context выглядят как "./Element.jsx" или "./Element.example.com.jsx"
  context.keys().forEach((key: string) => {
    // Разбираем имя файла
    // Регулярка объяснение:
    // \.\/    — начало строки "./"
    // (.*?)  — базовое имя компонента (жадно, но минимально)
    // ((?:\.[^.]+)?) — необязательный суффикс, начинающийся с точки (например, ".example.com")
    // \.jsx$  — окончание имени файла
    const match = key.match(/\.\/(.*?)(\.[^.]+)?\.(jsx|tsx)$/);
    if (!match) return;

    const componentName = cleanFolders(match[1]); // например, "Element" или "Button"
    const suffix = match[2] || ""; // либо ".example.com", либо пустая строка для дефолтной версии

    // Если для этого компонента ещё не создавали запись – создаём
    if (!componentsMap[componentName]) {
      componentsMap[componentName] = {
        default: null,
        domainSpecific: {}, // здесь будут записи вида { 'example.com': Component }
      };
    }

    if (suffix) {
      // Убираем точку из суффикса
      const domainKey = suffix.slice(1);
      componentsMap[componentName].domainSpecific[domainKey] =
        context(key).default;
    } else {
      // Дефолтная версия
      componentsMap[componentName].default = context(key).default;
    }
  });

  // Формируем объект с окончательными компонентами, выбирая для каждого
  // если есть доменно-специфичная версия для текущего домена, то отдаём её, иначе дефолтную
  const resolvedComponents: Record<string, any> = {};
  Object.keys(componentsMap).forEach((componentName) => {
    const { default: DefaultComponent, domainSpecific } =
      componentsMap[componentName];
    resolvedComponents[componentName] =
      domainSpecific[provider ?? ""] || DefaultComponent;
  });

  return resolvedComponents;
};

const ProviderUtils = {
  getProvider: getProvider,
  getIsDebug: getIsDebug,
  resolveComponents: resolveComponents,
};

export default ProviderUtils;
